import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function postItems({ body }) {
  return BaseService.post(REST.ITEMS, body);
}

function putItems({ body, id }) {
  return BaseService.put(REST.ITEMS_ID(id), body);
}

function getItems(params) {
  return BaseService.get(REST.ITEMS, {
    params: paramsFilter({ params }),
  });
}

function deleteItems({ id }) {
  return BaseService.delete(REST.ITEMS_ID(id));
}

function getLogItems(params) {
  return BaseService.get(REST.ITEMS_LOG, {
    params: paramsFilter({ params }),
  });
}

export default {
  getItems,
  postItems,
  putItems,
  deleteItems,
  getLogItems,
};
